import React from 'react';
import logo from 'assets/imgs/logo.png';

const Logo = () => <img src={logo} alt="LizardThemes" className="logo" />;

export default Logo;